import styled from "styled-components";

import Body from "../../../../shared/styles/typography/Body.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";

const StyledInfoCard = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 0 24px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};

  ${Body} {
    white-space: pre-wrap;
  }

  ${Summary} {
    margin-top: 16px;
    font-weight: 600;
  }

  ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.primary2};
  }
`;

export default StyledInfoCard;
